import { Store } from "redux";
import { SDK } from "../../../@sdk/sdk";
import { setOrganization } from "./workspace.actions";

export const loadOrganization = async (store: Store) => {
  const res = await SDK.getCurrentOrganization();
  store.dispatch(setOrganization(res));
};
